import { Controller } from "@hotwired/stimulus"

// Writes into the conversation composer textarea. Used by the quick-reply rail chips
// (which live in their own turbo frame, outside the quick-reply-picker controller
// element, and so need a standalone way to reach the shared composer) and by the
// composer's clear button, which is the same action with empty content.
//
// Writes go through execCommand so the browser records them on its native undo stack:
// setting `.value` directly wipes that stack, which silently destroys a half-typed
// draft the moment an advocate taps a chip. Mobile has no practical undo, which is why
// the clear button exists alongside it.
//
// Example usage:
//   <button data-controller="fill-composer"
//           data-fill-composer-content-value="Hi there!"
//           data-action="fill-composer#fill">Use reply</button>
//
// Values:
//   - content: the text to drop into the composer textarea; empty clears it
export default class extends Controller {
  static values = { content: String }

  fill(event) {
    event.preventDefault()

    const textarea = document.querySelector(
      "#conversation-send-message-form textarea"
    )
    if (!textarea) return

    textarea.focus()
    textarea.setSelectionRange(0, textarea.value.length)

    // execCommand is deprecated but remains the only way to write text the browser
    // treats as a user edit, and it fires `input` itself. Fall back to a plain
    // assignment (no undo) if a browser ever drops it.
    const applied = this.contentValue
      ? document.execCommand("insertText", false, this.contentValue)
      : document.execCommand("delete")

    if (!applied) {
      textarea.value = this.contentValue
      textarea.dispatchEvent(new Event("input"))
    }
  }
}
